<template>
  <div>
    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="m-0 mb-1">
        <b-row>
          <!-- Per Page -->
          <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>Show</label>
            <v-select v-model="perPage" :options="perPageOptions" :clearable="false" class="per-page-selector d-inline-block mx-50" />
            <label>entries</label>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refAccountFailListTable"
        class="position-relative"
        :items.sync="accountsFail"
        responsive
        :fields="failTableColumns"
        :filter.sync="searchQuery"
        :filterByFormatted="true"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No accounts modified n this session"
        :sort-desc.sync="isSortDirDesc"
        :current-page.sync="currentPageFail"
        :per-page.sync="perPage"
        :bordered="true"
      >
        <!-- Column: Student Id -->
        <template #cell(studentId)="data">
          {{ data.item.student.myIpId }}
        </template>

        <!-- Column: Student Full Name -->
        <template #cell(row.fullName)="data">
          <template v-if="data.item.row.student">
            <b-link
              :to="{ name: 'apps-students-view', params: { id: data.item.row.student.id } }"
              class="font-weight-bold d-block text-nowrap"
              target="_blank"
            >
              {{ data.item.row.student.fullName }}
            </b-link>
            <small class="text-muted">{{ data.item.row.student.myIpId }}</small>
          </template>
          <template v-else>
            <b-link class="font-weight-bold d-block text-nowrap" target="_blank">
              {{ data.item.row.fullName }}
            </b-link>
          </template>
        </template>

        <!-- Column: Attributes - Program -->
        <template #cell(row.fundingSource)="data">
          <b-badge :variant="`light-info`" class="text-nowrap text-capitalize">
            {{ title(data.item.row['Funding Type']) }}
          </b-badge>
        </template>

        <!-- Column: Attributes - Course Name -->
        <template #cell(row.courseName)="data">
          {{ data.item.row['Course Name'] }}
        </template>

        <!-- Column: balance -->
        <template #cell(row.index)="data">
          <span class="text-nowrap">{{ data.item.index + 2 /* 0idx+header */ }}</span>
        </template>

        <!-- Column: balance -->
        <template #cell(reason)="data">
          <span class="text-nowrap">{{ data.item.error }}</span>
        </template>

        <!--      &lt;!&ndash; Column: Cohort &ndash;&gt;-->
        <!--      <template #cell(payment.date)="data">-->
        <!--        {{ moment(data.item.payment.date).format('L') }}-->
        <!--      </template>-->

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge :variant="`light-info`" class="text-capitalize">
            {{ title(data.item.status) }}
          </b-badge>
        </template>

        <!-- Column: Status -->
        <template #cell(isNew)="data">
          <b-badge :variant="`light-info`" class="text-capitalize">
            {{ data.item.isNew ? 'Created' : 'Existing' }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="text-center text-nowrap">
            <b-dropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body p-0" />
              </template>

              <b-dropdown-item :to="{ name: 'apps-accounting-receivable-account-edit', params: { id: data.item.id } }" target="_blank">
                <feather-icon icon="FileTextIcon" />
                <span class="align-middle ml-50">Edit</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
      </b-table>
      <div class="m-0">
        <b-row>
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
            <span class="text-muted">Showing {{ failDataMeta.from }} to {{ failDataMeta.to }} of {{ failDataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
            <b-pagination
              v-model="currentPageFail"
              :total-rows="accountsFail.length"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="m-0 mb-1">
        <b-row>
          <!-- Per Page -->
          <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>Show</label>
            <v-select v-model="perPage" :options="perPageOptions" :clearable="false" class="per-page-selector d-inline-block mx-50" />
            <label>entries</label>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refAccountSuccessListTable"
        class="position-relative"
        :items.sync="accountsSuccess"
        responsive
        :fields="successTableColumns"
        :filter.sync="searchQuery"
        :filterByFormatted="true"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No accounts modified n this session"
        :sort-desc.sync="isSortDirDesc"
        :current-page.sync="currentPageSuccess"
        :per-page.sync="perPage"
        :bordered="true"
      >
        <!-- Column: Student Id -->
        <template #cell(studentId)="data">
          {{ data.item.student.myIpId }}
        </template>

        <!-- Column: Student Full Name -->
        <template #cell(student.fullName)="data">
          <b-link
            :to="{ name: 'apps-accounting-receivable-account-view', params: { id: data.item.id } }"
            class="font-weight-bold d-block text-nowrap"
            target="_blank"
          >
            {{ data.item.student.fullName }}
          </b-link>
          <small class="text-muted">{{ data.item.student.myIpId }}</small>
        </template>

        <!-- Column: Cohort -->
        <template #cell(cohort)="data">
          <div class="text-nowrap" v-if="data.item.cohort">
            <b-link
              :to="{ name: 'apps-accounting-receivable-cohort-view', params: { id: data.item.cohort.id } }"
              class="font-weight-bold d-block text-nowrap"
              target="_blank"
            >
              {{ data.item.cohort.name }}
            </b-link>
            <small class="text-muted">{{ title(data.item.cohort.status) }}</small>
          </div>
          <div class="text-nowrap" v-else>Unassigned</div>
        </template>

        <!-- Column: Attributes - Program -->
        <template #cell(profile.attributes.fundingSource)="data">
          <b-badge v-if="data.item.profile" :variant="`light-info`" class="text-nowrap text-capitalize">
            {{ title(data.item.profile.attributes.fundingSource) }}
          </b-badge>
          <div class="text-nowrap" v-else>Unassigned</div>
        </template>

        <!-- Column: balance -->
        <template #cell(total)="data">
          <span class="text-nowrap">{{ money(data.item.total) }}</span>
        </template>
        <!-- Column: balance -->
        <template #cell(totalPaid)="data">
          <span class="text-nowrap">{{ money(data.item.totalPaid) }}</span>
        </template>
        <!-- Column: balance -->
        <template #cell(balanace)="data">
          <span class="text-nowrap">{{ money(data.item.balance) }}</span>
        </template>

        <!--      &lt;!&ndash; Column: Cohort &ndash;&gt;-->
        <!--      <template #cell(payment.date)="data">-->
        <!--        {{ moment(data.item.payment.date).format('L') }}-->
        <!--      </template>-->

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge :variant="`light-info`" class="text-capitalize">
            {{ title(data.item.status) }}
          </b-badge>
        </template>

        <!-- Column: Status -->
        <template #cell(isNew)="data">
          <b-badge :variant="`light-info`" class="text-capitalize">
            {{ data.item.isNew ? 'Created' : 'Existing' }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="text-center text-nowrap">
            <b-dropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body p-0" />
              </template>

              <b-dropdown-item :to="{ name: 'apps-accounting-receivable-account-edit', params: { id: data.item.id } }" target="_blank">
                <feather-icon icon="FileTextIcon" />
                <span class="align-middle ml-50">Edit</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
      </b-table>
      <div class="m-0">
        <b-row>
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
            <span class="text-muted"
              >Showing {{ successDataMeta.from }} to {{ successDataMeta.to }} of {{ successDataMeta.of }} entries</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
            <b-pagination
              v-model="currentPageSuccess"
              :total-rows="accountsSuccess.length"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormInput,
  BLink,
  BMedia,
  BPagination,
  BRow,
  BTable,
  BTooltip,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import store from '@/store';
import { ref } from '@vue/composition-api';
import { avatarText, title } from '@core/utils/filter';
import moment from 'moment';
import useAccountImport from '@/views/apps/accounting/receivable/account/import/useAccountImport';
import { computed } from '@vue/composition-api/dist/vue-composition-api';

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,

    vSelect,
  },
  data: () => {
    return {
      isAddCohortOpen: false,
      cohortAccount: undefined,
    };
  },
  methods: {
    money(v) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(v);
    },
    archiveAccount(accountId) {
      store
        .dispatch('receivableStoreModule/updateAccount', {
          id: accountId,
          accountData: {
            status: 'archived',
          },
        })
        .then((response) => {
          this.refetchData();
        });
    },
  },
  computed: {
    hasApplicableFilter() {
      return true;
    },
  },
  props: ['results'],
  setup(props, { emit }) {
    const {
      perPage,
      currentPageFail,
      currentPageSuccess,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,

      // UI

      // Extra Filters
      statusFilter,
      statusOptions,
      fundingFilter,
      fundingSourceOptions,

      //
      dateFilter,
    } = useAccountImport();

    const refAccountFailListTable = ref(null);
    const refAccountSuccessListTable = ref(null);

    const results = ref(props.results);

    console.log('>> using results in summary:', results.value);

    const accountsFail = computed(() => results.value.filter((x) => x.state === 'error'));
    const accountsSuccess = computed(() => results.value.filter((x) => x.state === 'success').map((x) => ({ ...x.success, ...x })));

    console.log('>> using success:', accountsSuccess.value);

    const failTableColumns = ref([
      { key: 'row.index', label: 'Row', stickyColumn: true, variant: 'primary', sortable: true },
      { key: 'row.fullName', label: 'Name', stickyColumn: true, variant: 'primary', sortable: true },
      { key: 'row.fundingSource', label: 'Funding', sortable: true },
      { key: 'row.courseName', label: 'Course', sortable: true },
      { key: 'reason', label: 'Reason', sortable: true },
      { key: 'actions' },
    ]);

    const successTableColumns = ref([
      { key: 'student.fullName', label: 'Name', stickyColumn: true, variant: 'primary', sortable: true },
      { key: 'student.email', label: 'Email', sortable: true },
      { key: 'cohort', label: 'Cohort' },
      { key: 'profile.attributes.fundingSource', label: 'Funding', sortable: true },

      { key: 'total', label: 'Total', sortable: true },
      { key: 'totalPaid', label: 'Total Paid', sortable: true },
      { key: 'balance', label: 'Balance', sortable: true },
      { key: 'comments', label: 'Comments', sortable: true },
      { key: 'status', sortable: true },
      { key: 'isNew', label: 'New?', sortable: true },
      { key: 'actions' },
    ]);

    const failDataMeta = computed(() => {
      const localItemsCount = refAccountFailListTable.value ? refAccountFailListTable.value.localItems.length : 0;
      return {
        from: perPage.value * (currentPageFail.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPageFail.value - 1) + localItemsCount,
        of: accountsFail.value.length,
      };
    });

    const successDataMeta = computed(() => {
      const localItemsCount = refAccountSuccessListTable.value ? refAccountSuccessListTable.value.localItems.length : 0;
      return {
        from: perPage.value * (currentPageSuccess.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPageSuccess.value - 1) + localItemsCount,
        of: accountsSuccess.value.length,
      };
    });

    return {
      // Sidebar

      failTableColumns,
      accountsFail,
      successTableColumns,
      accountsSuccess,

      perPage,

      currentPageFail,
      currentPageSuccess,
      failDataMeta,
      successDataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refAccountFailListTable,
      refAccountSuccessListTable,

      // Filter
      avatarText,
      title,
      moment,

      // UI

      // Extra Filters
      statusFilter,
      statusOptions,
      fundingFilter,
      fundingSourceOptions,
      dateFilter,
    };
  },
};
</script>

<style lang="scss">
.per-page-selector {
  width: 90px;
}
</style>
